/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Ic_Contact_VisibilityInputs */



/**
* | output |
* | --- |
* | "Your community links are visible to all users. Your contact info is only visible to NCs." |
*
* @param {Profile_Ic_Contact_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_ic_contact_visibility = /** @type {((inputs?: Profile_Ic_Contact_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Ic_Contact_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos liens communautaires sont visibles par tous les utilisateurs. Vos informations de contact sont visibles uniquement par les NC.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tus enlaces de comunidad son visibles para todos los usuarios. Tu información de contacto solo es visible para los NC.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seus links da comunidade são visíveis para todos os usuários. Suas informações de contato são visíveis apenas para os NC.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I tuoi link della comunità sono visibili a tutti gli utenti. Le tue informazioni di contatto sono visibili solo agli NC.")
	return /** @type {LocalizedString} */ ("Your community links are visible to all users. Your contact info is only visible to NCs.")
});